/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

export const Button = ({
  children,
  className,
  hasError,
  color,
  icon,
  type,
  size,
  ...rest
}) => (
  // eslint-disable-next-line react/button-has-type
  <button
    type={type}
    className={`btn

    ${className ? ` btn--${className}` : ''}
    ${hasError ? ' has-error' : ''}
    ${color ? ` btn--${color}` : ''}
    ${size ? ` btn--${size}` : ''}
    
    `}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  >
    {children}
    {icon && <span className={`${icon} inline-block pl1`} />}
  </button>
);

Button.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  type: PropTypes.string,
  className: PropTypes.string,
  hasError: PropTypes.bool,
  color: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string
};

Button.defaultProps = {
  className: '',
  hasError: false,
  color: '',
  icon: '',
  type: 'button',
  size: null
};
